module.exports = __webpack_public_path__ + "static/media/skating.bbaf654b.svg";